const ForecastMedia: React.FC<{
  media: string;
  title: string;
}> = ({ media, title }) => {
  console.log("media", media, title);
  return (
    <div className="absolute inset-0 z-0">
      {media.includes(".mp4") ? (
        <>
          <video
            key={media}
            className="h-full w-full object-cover"
            autoPlay
            loop
            muted
            playsInline
          >
            <source src={`/media/${media}`} type="video/mp4" />
            Таны хөтөч видео дэмждэггүй.
          </video>
        </>
      ) : (
        <>
          <img
            key={media}
            className="h-full w-full object-cover"
            // src={`/media/ub.png`}
            src={`/media/${media}`}
            alt={`${title}-ын цаг агаарын дэлгэц`}
            loading="eager"
          />
        </>
      )}
    </div>
  );
};

export default ForecastMedia;
